function getOpt(dataObj) {
	let xData=dataObj.xData;
	let yData1=dataObj.yData1;
	let yData2=dataObj.yData2;
  let legend = null;
  if(bmeConfig.customerSign == 67) {
    legend = ["厂区"]
  } else if(bmeConfig.customerSign == 92) {
    legend = ['厂区', '国控']
  } else {
    legend = ['厂区', '省控']
  }
  let opt_ =  {
    backgroundColor: 'transparent',
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        lineStyle: {
          color: '#57617B'
        }
      }
    },
    legend: {
      icon: 'rect',
      itemWidth: 14,
      itemHeight: 5,
      itemGap: 13,
      data: legend,
      right: '4%',
      textStyle: {
        fontSize: 20,
        color: '#fff'
      }
    },
    grid: {
      top:"15%",
      left: '4%',
      right: '10%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      boundaryGap: false,
      axisLine: {
        lineStyle: {
          color: 'rgb(48, 95, 115)',
        }
      },
      axisLabel: { //坐标轴刻度标签的相关设置
        textStyle: {
          color: 'rgba(255,255,255,.5)',
          margin: 15,
          fontSize: 20,
        },
      },
      axisTick: {
        show: false,
      },
      data: xData
    }],
    yAxis: {
      type: 'value',
//    name: 'μg/m3',
//    max: 100,
//    min: 0,
      axisTick: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: 'rgb(48, 95, 115)'
        }
      },
      axisLabel: {
        margin: 10,
        textStyle: {
          color: "rgba(255,255,255,.5)",
          fontSize: 24
        }
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(48, 95, 115,.3)'
        }
      }
    },
    series: [{
      name: '厂区',
      type: 'line',
      smooth: true,
      symbol: 'circle',
      symbolSize: 5,
      showSymbol: false,
      lineStyle: {
        normal: {
          width: 2,
          color: "rgba(62, 234, 236, 1)"
        }
      },
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: 'rgba(62, 234, 236, 0.2)'
          }, {
            offset: 0.8,
            color: 'rgba(62, 234, 236, 0.05)'
          }], false),
          shadowColor: 'rgba(62, 234, 236, 0)',
          shadowBlur: 10
        }
      },
      itemStyle: {
        normal: {
          color: "rgba(62, 234, 236, 1)",

        }
      },
      data: yData1
    }]
  };
  let seriseYdata_2 =  { //国控或省控
    name: (bmeConfig.customerSign == 92) ? '国控' :'省控',
    type: 'line',
    smooth: true,
    symbol: 'circle',
    symbolSize: 5,
    showSymbol: false,
    lineStyle: {
      normal: {
        width: 2,
        color: 'rgba(132, 103, 37, 1)',
//        color: "#6C8EFF"
      }
    },
    itemStyle: {
      normal: {
        color: 'rgba(132, 103, 37, 1)',
//		  color: "#6C8EFF"
      }
    },
    areaStyle: {
      normal: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: 'rgba(132, 103, 37, 0.3)'
        }, {
          offset: 0.8,
          color: 'rgba(132, 103, 37, 0.05)'
        }], false),
        shadowColor: 'rgba(132, 103, 37, 0)',
        shadowBlur: 10
      }
    },
    data: yData2
  }
  if(bmeConfig.customerSign != 67) {
    opt_.series.push(seriseYdata_2)
  }
  return opt_;
}

export default getOpt;